export default {"src":"/_next/static/media/proteins.8980844f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};